const SELECTORS = Selectors({
  gallery: 'galleria-gallery'
})

const $galleries = document.querySelectorAll(SELECTORS.asClass('gallery'))

const fn = {
  init: () => {
    $galleries.forEach($el => {
      window.Galleria.loadTheme($el.dataset.dir + '/galleria.folio.min.js')

      window.Galleria.run($($el), {
        height: parseInt($($el).css('height')),
        wait: true,
        flickr: 'set:' + $el.dataset.album,
        flickrOptions: {
          max: 200
        }
      })

      window.Galleria.ready(function () {
        this.bind('thumbnail', function (e) {
          $(e.thumbTarget).parent().mousedown((function (gallery, index) {
            return function() {
              $(this).unbind('click')
              gallery._lightbox.show(index)
            }
          }( this, e.index )))
        })
      })
    })
  }
}

export default {
  can: () => $galleries.length,
  run: fn.init
}
